import { useQueries } from "@tanstack/react-query";
import { useMemo } from "react";

import type { ChatTranscriptItem } from "~/ai-chat/model/chat-message";
import { collectConversationArtifacts, type ConversationArtifact } from "~/ai-chat/model/conversation-artifacts";
import { resourceExistsQueryOptions } from "~/resource/data-source/api/resource-exists-query-options";

// The Artifacts panel is derived from the assistant's links, which can name resources that
// don't exist. Only confirmed ones are listed, matching the transcript chips. The lookups share
// cache entries with the chips, so the panel adds no requests of its own.
export function useConversationArtifacts(messages: ChatTranscriptItem[]): ConversationArtifact[] {
  // Stable reference for useQueries (ref-sensitive: it subscribes per array entry).
  const artifacts = useMemo(() => collectConversationArtifacts(messages), [messages]);
  return useQueries({
    queries: artifacts.map((artifact) => resourceExistsQueryOptions(artifact.resourceId)),
    combine: (results) => artifacts.filter((_, index) => results[index].data === true),
  });
}
